import { get } from 'lodash'
import moment from 'moment'
import { required, minNights, minLength } from 'utils/validation'
import { AJ_EVENT_CATEGORIES } from 'constants/enums'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'
import { email } from '../../../../utils/validation'

const validate = (values, props) => {
  const isAssessorManagementEnabled = get(props,
    `configuration.values.${CONFIGURATION_KEYS.isAssessorManagementEnabled.id}.booleanValue`)

  let errors = {
    helpers: {
      category: required(get(values, 'helpers.category')),
      location: required(get(values, 'helpers.location')),
      countryId: required(get(values, 'helpers.countryId'))
    },
    title: required(get(values, 'title')),
    activityCategory: {
      id: required(get(values, 'activityCategory.id', null))
    },
    transportationModes: required(get(values, 'transportationModes')) || minLength(1)(get(values, 'transportationModes')),
    aim: required(get(values, 'aim')),
    startDate: required(get(values, 'startDate')),
    endDate: required(get(values, 'endDate'))
  }

  if (isAssessorManagementEnabled) {
    const setupAssessorId = get(values, 'setupAssessorId')
    const assessorDataIsNeeded = setupAssessorId === 0
    errors.setupAssessorId = required(get(values, 'setupAssessorId'))
    errors.assessorTitle = assessorDataIsNeeded && required(get(values, 'assessorTitle'))
    errors.assessorName = assessorDataIsNeeded && required(get(values, 'assessorName'))
    errors.assessorEmail = assessorDataIsNeeded && required(get(values, 'assessorEmail'))
    errors.assessorPhone = assessorDataIsNeeded && required(get(values, 'assessorPhone'))
    errors.assessorRelevantExperience = assessorDataIsNeeded && required(get(values, 'assessorRelevantExperience'))
    errors.supervisorEmail = email(get(values, 'supervisorEmail'))
  } else {
    errors.supervisorEmail = email(get(values, 'supervisorEmail'))
  }

  const awardStartDate =
    get(props, 'awardStartDate') &&
    moment(props.awardStartDate)
      .hour(0)
      .seconds(0)
      .toISOString()

  if (get(values, 'startDate') > get(values, 'endDate')) {
    errors.endDate = {
      text: 'End date has to be after start date',
      intlKey: 'errors.end_date_after',
      values: {}
    }
  } else if (awardStartDate && awardStartDate >= get(values, 'startDate')) {
    errors.startDate = {
      text: 'Start date cannot be before current award begun.',
      intlKey: 'errors.start_date_after_award_start'
    }
  }

  if (
    get(values, 'startDate') <= get(values, 'endDate') &&
    get(props, 'eventCategory') === AJ_EVENT_CATEGORIES.qualification.id &&
    get(props, 'awardLevel.value', false)
  ) {
    errors.endDate = minNights(
      get(values, 'startDate'),
      get(values, 'endDate'),
      {
        awardLevelValue: get(props, 'awardLevel.value', false)
      }
    )
  }

  return errors
}

export default validate
